const services = [
  {
    id: 1,
    title: 'Technology Solution',
    slug: 'technology-solution',
    icon: '/assets/img/icon/service_card_1.svg',
    text: 'Risus turpis id mauris tellus ultricies cras nulla.',
    detailsImage: '/assets/img/service/service_details.jpg',
    description: 'Holisticly benchmark functional products before excellent methods of empowerment. Seamlessly visualize innovative web-readiness whereas extensive initiatives. Completely unleash frictionless data via end-to-end services. Continually unleash virtual e-tailers through magnetic core competencies. Interactively engage distributed alignments via focused alignments. Dynamically fabricate excellent innovation for go forward technology. Intrinsicly impact empowered scenarios after cost effective outsourcing. Synergistically productivate pandemic e-business rather than state of the art e-tailers. Continually expedite customized information with go forward potentialities.',
    features: [
      'We Provide Flexible IT Services',
      'Best IT Solution with Our Team',
      'Award Winning Digital Solutions',
      '25 Years Skilled Experience'
    ],
    innerImages: [
      '/assets/img/service/service_inner_1.jpg',
      '/assets/img/service/service_inner_2.jpg',
      '/assets/img/service/service_inner_3.jpg'
    ],
    challengeTitle: 'The challenge of project',
    challengeText: 'Interactively engage distributed alignments via focused alignments. Dynamically fabricate excellent innovation for go forward technology. Intrinsicly impact empowered scenarios after cost effective outsourcing.',
    faqs: [
      {
        question: 'What Is The Design Process For Branding?',
        answer: 'Progressively communicate flexible human capital with best-of-breed schemas. Completely develop 2.0 infrastructures via bleeding-edge opportunities.'
      },
      {
        question: 'How Much Does Logo Design Services Cost?',
        answer: 'Objectively seize dynamic e-services and accurate markets. Completely initiate world-class leadership skills via fully tested applications.'
      },
      {
        question: 'How Long Will It Take To Complete My Project?',
        answer: 'Continually unleash virtual e-tailers through magnetic core competencies. Interactively engage distributed alignments via focused alignments.'
      },
      {
        question: 'What Is Included In A Round Of Revisions?',
        answer: 'Dynamically fabricate excellent innovation for go forward technology. Intrinsicly impact empowered scenarios after cost effective outsourcing.'
      }
    ]
  },
  {
    id: 2,
    title: 'IT Management Service',
    slug: 'it-management-service',
    icon: '/assets/img/icon/service_card_2.svg',
    text: 'Developing a comprehense IT strategy that aligns.',
    detailsImage: '/assets/img/service/service_details.jpg',
    description: 'Developing a comprehensive IT strategy that aligns with your business goals. We help organizations optimize their technology infrastructure and improve operational efficiency. Our team of experts works closely with you to understand your unique challenges and develop tailored solutions that drive growth and innovation. From network design and implementation to cloud migration and cybersecurity, we provide end-to-end IT services that ensure your business stays competitive in today\'s digital landscape.',
    features: [
      'Comprehensive IT Strategy',
      'Infrastructure Optimization',
      '24/7 Technical Support',
      'Proactive Monitoring'
    ],
    innerImages: [
      '/assets/img/service/service_inner_1.jpg',
      '/assets/img/service/service_inner_2.jpg',
      '/assets/img/service/service_inner_3.jpg'
    ],
    challengeTitle: 'IT Management Challenges',
    challengeText: 'Managing complex IT environments requires expertise and strategic planning. We help businesses overcome these challenges with proven methodologies.',
    faqs: [
      {
        question: 'What IT Management Services Do You Offer?',
        answer: 'We offer comprehensive IT management services including infrastructure monitoring, network security, cloud solutions, and technical support.'
      },
      {
        question: 'How Do You Ensure System Reliability?',
        answer: 'Our proactive monitoring systems detect issues before they become problems, ensuring maximum uptime and reliability for your business operations.'
      },
      {
        question: 'Do You Provide 24/7 Support?',
        answer: 'Yes, our dedicated support team is available 24/7 to address any technical issues and ensure your systems run smoothly.'
      },
      {
        question: 'How Do You Handle IT Security?',
        answer: 'We implement multi-layered security solutions including firewalls, intrusion detection, and regular security audits to protect your data.'
      }
    ]
  },
  {
    id: 3,
    title: 'Website & Mobile App Design',
    slug: 'website-mobile-app-design',
    icon: '/assets/img/icon/service_card_3.svg',
    text: 'Website and mobile apps design are critical.',
    detailsImage: '/assets/img/service/service_details.jpg',
    description: 'Website and mobile apps design are critical for modern businesses. We create stunning, user-friendly designs that drive engagement and conversions. Our design process begins with thorough research and user analysis to understand your target audience and business objectives. We then craft intuitive interfaces that provide seamless experiences across all devices and platforms. From concept to launch, we ensure every design element serves a purpose and contributes to your brand\'s success in the digital marketplace.',
    features: [
      'User-Centric Design',
      'Responsive Layouts',
      'Cross-Platform Compatibility',
      'Modern UI/UX Standards'
    ],
    innerImages: [
      '/assets/img/service/service_inner_1.jpg',
      '/assets/img/service/service_inner_2.jpg',
      '/assets/img/service/service_inner_3.jpg'
    ],
    challengeTitle: 'Design Challenges',
    challengeText: 'Creating designs that work across all devices and platforms requires deep understanding of user behavior and technical constraints.',
    faqs: [
      {
        question: 'What Design Services Do You Provide?',
        answer: 'We provide comprehensive design services including website design, mobile app design, UI/UX design, and brand identity development.'
      },
      {
        question: 'How Do You Ensure Mobile Responsiveness?',
        answer: 'We use responsive design principles and test across multiple devices to ensure optimal user experience on all screen sizes.'
      },
      {
        question: 'What Is Your Design Process?',
        answer: 'Our design process includes research, wireframing, prototyping, and iterative testing to deliver designs that meet your business objectives.'
      },
      {
        question: 'Do You Provide Design Revisions?',
        answer: 'Yes, we provide multiple revision rounds to ensure the final design meets your expectations and aligns with your brand.'
      }
    ]
  },
  {
    id: 4,
    title: 'Data Tracking Security',
    slug: 'data-tracking-security',
    icon: '/assets/img/icon/service_card_4.svg',
    text: 'Encryption is a method of converting sensitive.',
    detailsImage: '/assets/img/service/service_details.jpg',
    description: 'Encryption is a method of converting sensitive data into a secure format. We provide comprehensive data security solutions to protect your business information from unauthorized access and cyber threats. Our security experts implement multi-layered protection strategies including advanced encryption protocols, real-time threat monitoring, and automated incident response systems. We help you maintain compliance with industry regulations while ensuring your critical business data remains secure and accessible only to authorized personnel.',
    features: [
      'End-to-End Encryption',
      'Real-Time Monitoring',
      'Compliance Management',
      'Threat Detection'
    ],
    innerImages: [
      '/assets/img/service/service_inner_1.jpg',
      '/assets/img/service/service_inner_2.jpg',
      '/assets/img/service/service_inner_3.jpg'
    ],
    challengeTitle: 'Security Challenges',
    challengeText: 'Protecting sensitive data in today\'s digital landscape requires advanced security measures and constant vigilance against evolving threats.',
    faqs: [
      {
        question: 'What Data Security Measures Do You Implement?',
        answer: 'We implement advanced encryption, access controls, monitoring systems, and regular security audits to protect your data.'
      },
      {
        question: 'How Do You Ensure Compliance?',
        answer: 'Our solutions are designed to meet industry standards and regulatory requirements including GDPR, HIPAA, and SOC 2.'
      },
      {
        question: 'What Happens In Case Of A Security Breach?',
        answer: 'We have incident response protocols in place and provide 24/7 monitoring to detect and respond to security threats immediately.'
      },
      {
        question: 'How Do You Handle Data Backups?',
        answer: 'We implement automated backup systems with redundancy to ensure your data is always protected and recoverable.'
      }
    ]
  },
  {
    id: 5,
    title: 'Cloud Computing Solutions',
    slug: 'cloud-computing-solutions',
    icon: '/assets/img/icon/service_card_3.svg',
    text: 'Scalable cloud infrastructure tailored to your business needs.',
    detailsImage: '/assets/img/service/service_details.jpg',
    description: 'Accelerate your digital transformation with our enterprise-grade cloud computing solutions. We design, migrate, and manage cloud environments across AWS, Azure, and Google Cloud platforms. Our certified cloud architects assess your existing infrastructure and craft a migration strategy that minimizes downtime while maximizing performance and cost efficiency. Whether you need a hybrid cloud setup, serverless architecture, or full cloud-native deployment, we deliver scalable solutions that grow alongside your business and reduce operational overhead.',
    features: [
      'Multi-Cloud Architecture',
      'Seamless Migration Strategy',
      'Cost Optimization',
      'Auto-Scaling Infrastructure'
    ],
    innerImages: [
      '/assets/img/service/service_inner_1.jpg',
      '/assets/img/service/service_inner_2.jpg',
      '/assets/img/service/service_inner_3.jpg'
    ],
    challengeTitle: 'The Challenge of Cloud Migration',
    challengeText: 'Migrating legacy systems to the cloud demands careful planning, zero-downtime execution, and deep expertise across platforms. We handle the complexity so your team can focus on growth.',
    faqs: [
      {
        question: 'Which Cloud Platforms Do You Support?',
        answer: 'We work with all major cloud providers including AWS, Microsoft Azure, and Google Cloud, as well as hybrid and multi-cloud environments.'
      },
      {
        question: 'How Long Does A Cloud Migration Take?',
        answer: 'Migration timelines vary based on infrastructure size and complexity. We provide a detailed roadmap after an initial assessment of your systems.'
      },
      {
        question: 'Will There Be Downtime During Migration?',
        answer: 'We use proven zero-downtime migration strategies and rollback plans to ensure your business operations continue uninterrupted throughout the process.'
      },
      {
        question: 'How Do You Optimize Cloud Costs?',
        answer: 'We continuously analyze resource usage and apply right-sizing, reserved instances, and automated scaling to keep your cloud spending efficient.'
      }
    ]
  },
  {
    id: 6,
    title: 'AI & Automation Integration',
    slug: 'ai-automation-integration',
    icon: '/assets/img/icon/service_card_2.svg',
    text: 'Intelligent automation that streamlines operations and reduces costs.',
    detailsImage: '/assets/img/service/service_details.jpg',
    description: 'Unlock the full potential of artificial intelligence and process automation for your business. We integrate AI-powered tools, machine learning models, and robotic process automation (RPA) into your existing workflows to eliminate repetitive tasks, reduce human error, and deliver actionable insights from your data. Our automation engineers work across industries to build intelligent pipelines — from customer support chatbots and predictive analytics dashboards to fully automated back-office operations — helping your team focus on high-value strategic work.',
    features: [
      'Custom AI Model Integration',
      'Robotic Process Automation',
      'Predictive Analytics',
      'Workflow Optimization'
    ],
    innerImages: [
      '/assets/img/service/service_inner_1.jpg',
      '/assets/img/service/service_inner_2.jpg',
      '/assets/img/service/service_inner_3.jpg'
    ],
    challengeTitle: 'The Challenge of Intelligent Automation',
    challengeText: 'Implementing AI without disrupting existing workflows is a common barrier for businesses. We bridge the gap between cutting-edge technology and practical, day-to-day operational needs.',
    faqs: [
      {
        question: 'What Processes Can Be Automated?',
        answer: 'We automate a wide range of processes including data entry, report generation, customer interactions, invoice processing, and IT operations.'
      },
      {
        question: 'Do We Need To Replace Existing Systems?',
        answer: 'No. Our solutions are designed to integrate with your current software stack, enhancing capabilities without requiring a full system replacement.'
      },
      {
        question: 'How Is The AI Model Trained For Our Business?',
        answer: 'We use your historical data and domain-specific inputs to train and fine-tune models that reflect your unique business processes and goals.'
      },
      {
        question: 'How Do You Measure Automation ROI?',
        answer: 'We establish clear KPIs before deployment and provide detailed performance reports showing time saved, error reduction, and cost efficiency gains.'
      }
    ]
  },
  {
    id: 7,
    title: 'Network Setup Infrastructure',
    slug: 'network-setup-infrastructure',
    icon: '/assets/img/icon/service_card_4.svg',
    text: 'Robust and reliable network solutions built for performance.',
    detailsImage: '/assets/img/service/service_details.jpg',
    description: 'A reliable network is the backbone of every successful business. We design and deploy enterprise-grade network infrastructure that ensures high availability, fast data transfer, and secure connectivity across all your locations. Our network engineers conduct a thorough site assessment before architecting solutions that include structured cabling, LAN/WAN configuration, VPN setup, and wireless network deployment. We also provide ongoing monitoring and management to ensure your network performs optimally as your organization scales and evolves.',
    features: [
      'LAN/WAN Design & Deployment',
      'Secure VPN Configuration',
      'Wireless Network Solutions',
      'Ongoing Network Monitoring'
    ],
    innerImages: [
      '/assets/img/service/service_inner_1.jpg',
      '/assets/img/service/service_inner_2.jpg',
      '/assets/img/service/service_inner_3.jpg'
    ],
    challengeTitle: 'The Challenge of Network Reliability',
    challengeText: 'Downtime and slow connectivity directly impact productivity and revenue. Building a network that is both resilient and scalable requires precise planning and expert execution.',
    faqs: [
      {
        question: 'What Types Of Networks Do You Set Up?',
        answer: 'We design and implement LAN, WAN, WLAN, and hybrid networks for businesses of all sizes, including multi-site and remote work environments.'
      },
      {
        question: 'How Do You Secure Our Network?',
        answer: 'We implement firewalls, intrusion prevention systems, network segmentation, and encrypted VPN tunnels to keep your network protected from threats.'
      },
      {
        question: 'Can You Upgrade Our Existing Network?',
        answer: 'Absolutely. We audit your current setup, identify bottlenecks and vulnerabilities, and implement targeted upgrades to improve speed and security.'
      },
      {
        question: 'Do You Offer Ongoing Network Management?',
        answer: 'Yes, we provide managed network services including 24/7 monitoring, performance reporting, and proactive maintenance to prevent issues before they occur.'
      }
    ]
  },
  {
    id: 8,
    title: 'Software Development',
    slug: 'software-development',
    icon: '/assets/img/icon/service_card_1.svg',
    text: 'Custom software engineered to solve your unique business challenges.',
    detailsImage: '/assets/img/service/service_details.jpg',
    description: 'We build high-performance, scalable software solutions tailored precisely to your business requirements. From enterprise web applications and SaaS platforms to internal tools and API integrations, our development team combines modern engineering practices with deep domain expertise to deliver products that perform reliably under real-world demands. We follow an agile development methodology with transparent communication at every sprint, ensuring the final product aligns with your vision, timeline, and budget — while remaining flexible to evolving business needs throughout the process.',
    features: [
      'Agile Development Process',
      'Scalable System Architecture',
      'API Design & Integration',
      'Post-Launch Support & Maintenance'
    ],
    innerImages: [
      '/assets/img/service/service_inner_1.jpg',
      '/assets/img/service/service_inner_2.jpg',
      '/assets/img/service/service_inner_3.jpg'
    ],
    challengeTitle: 'The Challenge of Custom Development',
    challengeText: 'Off-the-shelf software rarely fits every business need. Building custom solutions requires balancing technical complexity, evolving requirements, and tight delivery timelines without sacrificing quality.',
    faqs: [
      {
        question: 'What Technologies Do You Develop With?',
        answer: 'We work across a wide technology stack including React, Next.js, Node.js, Python, Laravel, and various cloud-native and database technologies.'
      },
      {
        question: 'How Do You Handle Changing Requirements?',
        answer: 'Our agile methodology embraces change. We work in iterative sprints and hold regular reviews so requirements can evolve without derailing the project.'
      },
      {
        question: 'Do You Provide Source Code Ownership?',
        answer: 'Yes. Upon project completion, full source code ownership and documentation are transferred to you with no licensing restrictions.'
      },
      {
        question: 'What Post-Launch Support Do You Offer?',
        answer: 'We provide dedicated maintenance plans covering bug fixes, performance monitoring, feature enhancements, and security updates after launch.'
      }
    ]
  }
];

export default services;
